import React from 'react'
import {AppContext} from "../AppContextProvider";

export const useAppContext = () => React.useContext(AppContext)